import React, { useState, useEffect, useContext } from "react";
import { styled } from "@mui/material/styles";
import "./Compertitorstyle.css";
import calendarpng from "./../Asset/New_Assert/ESO_Icon/Filter.svg";
import "react-datepicker/dist/react-datepicker.css";
import Box from "@mui/material/Box";
import { color } from "d3-color";
import { interpolateRgb } from "d3-interpolate";
import axios from "axios";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";
import Loader from "../CommonLoader";
import { ChartContainer, BarPlot, ChartsTooltip } from "@mui/x-charts";
import GooglePng from "../../../Icons/google.png";
import BingPng from "../../../Icons/bing.png";
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Keywordbar from "./../Rightsidebar/Keywordbar";
import { useNavigate } from "react-router-dom";
import { Commonfun, removeDuplicateDate } from './../Commonfun';
import { timezonechange } from './../Commonfun';
import { timezoneval } from './../Commonfun';
import { AppContext } from "../../../Context/Context";
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import CommonAlert from "../../../Commonalert/commonalert";
import { CheckboxMultiSelectOption, customCheckboxMultiSelect, customDropdownStyles, MultiValueCount, MultiValue } from "../../../Commonalert/commonDropdown";
import Select from 'react-select';
import DatagridComp from "../DatagridComp";
import PdfandCsv from "../PdfandCsv";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import { Container, Grid, Typography } from '@mui/material';
import UserActivityTracker from "../../../hooks/userActivityTracker";
import Chart from "react-apexcharts";


export default function Competitorlist() {

  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [cardData, setCardData] = useState([]);
  const [jobidData, setjobidData] = useState([]);
  const [selectjobid, setselectjobid] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [selectval, setSelectval] = useState([]);
  const [selectsecondval, setSelectsecondval] = useState([]);
  const [pagename, setPagename] = useState("Competitor Ranking")
  const [jobDate, setjobDate] = useState("");
  const [value, setValue] = useState("1");
  const [chartvalue, setChartvalue] = useState("4");
  const [domainval, setDomainval] = useState([])
  const [reportdata, setReportdata] = useState("");
  const [reporttwodata, setReporttwodata] = useState([]);
  const [columns, setColumns] = useState([]);
  const [SearchEngine, SetSearchEngine] = useState("");
  const [Countryoptions, SetCountryoptions] = useState([]);
  const [Stateoptions, SetStateoptions] = useState([]);
  const [CityOptions, SetCityOptions] = useState([]);
  const [Engineoptions, SetEngineoptions] = useState([]);
  const [Country, SetCountry] = useState("");
  const [State, SetState] = useState("");
  const [City, SetCity] = useState("");
  const [SectionOptions, SetSectionOptions] = useState([]);
  const [campaign, Setcampaign] = useState("");
  const [campaignoption, Setcampaignoption] = useState([]);
  const [ErrorMsg, SetErrorMsg] = useState("");
  const [locationvaldata, setlocationvaldata] = useState("");
  const [initialDateval, SetInitialDateval] = useState([]);
  const [autoheightval, SetAutoheightval] = useState(true)
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value
  const [dcampaignoption, Setdcampaignoption] = useState([]);
  const [dselectjobid, setdselectjobid] = useState([])
  const [prevdselectjobid, setprevdselectjobid] = useState([])
  const [dSearchEngine, SetdSearchEngine] = useState([])
  const [dCountryHandle, SetdCountryHandle] = useState([])
  const [dStateHandle, SetdStateHandle] = useState([])
  const [dCity, SetdCity] = useState([])
  const [System, SetSystem] = useState('desktop');
  const [Device, SetDevice] = useState('')
  const [toggle, setToggle] = useState(false);
  const [faqData, setfaqData] = useState("2")
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [freesiteaudit, setfreesiteaudit] = useState({ status: false, error: "" });
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [competitors, setCompetitors] = useState([]);
  const [competitorsValue, setCompetitorsValue] = useState(null);
  const [competitorModel, setCompetitorModel] = useState(false);
  const [selectCompError, setSelectCompError] = useState(null);
  const [summaryData, setSummaryData] = useState({
    "kpis": {},
    "visibility_share": {
      labels: [],
      top_3: [],
      top_10: [],
    },
  });

  const navigate = useNavigate();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handlechartChange = (event, newValue) => {
    setChartvalue(newValue);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const [validation, setValidation] = useState({
    dateerror: "",
  });
  let errors = { ...validation };
  let subtitle;
  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));

  const MyCustomNoRowsOverlay = () => (
    <StyledGridOverlay>
      <svg
        width="120"
        height="100"
        viewBox="0 0 184 152"
        aria-hidden
        focusable="false"
      >
        <g fill="none" fillRule="evenodd">
          <g transform="translate(24 31.67)">
            <ellipse
              className="ant-empty-img-5"
              cx="67.797"
              cy="106.89"
              rx="67.797"
              ry="12.668"
            />
            <path
              className="ant-empty-img-1"
              d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
            />
            <path
              className="ant-empty-img-2"
              d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
            />
            <path
              className="ant-empty-img-3"
              d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
            />
          </g>
          <path
            className="ant-empty-img-3"
            d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
          />
          <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
            <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
            <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
          </g>
        </g>
      </svg>
      <Box sx={{ mt: 1 }}>No Data</Box>
    </StyledGridOverlay>
  );

  const SetCountryHandle = async (value) => {
    SetStateoptions([]);
    SetdStateHandle([])
    if (value) {
      SetCountry(value.value);
      try {
        const statedatavalue = await axios.get(
          `${process.env.REACT_APP_API_URL}keywords/ranking_filter/?job_id=${selectjobid}&user_domain_id=${esodata.domaindata.value.header_selected}&campaign_id=${campaign}&search_engine_id=${SearchEngine}&country_id=${value.value}&filter_type=state`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          }
        ).catch((error) => {
          if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
          }
          else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
            navigate('/errorpages')
          }
        });
        if (statedatavalue?.data) {
          if (statedatavalue?.data?.states) {
            var Sections = [];
            statedatavalue.data.states.forEach((element) => {
              Sections.push({ label: element.search_engine_locale__state__state_name, value: element.search_engine_locale__state__id });
            });
            SetStateoptions(Sections);
            SetdStateHandle(Sections[0])
          }
        }

      } catch (err) {
        console.log(err)
      }


    }
  };

  const SetStateHandle = async (value) => {
    SetCityOptions([]);
    SetdCity([])
    if (value && value.value !== undefined) {
      SetState(value);

      const citydatavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/ranking_filter/?job_id=${selectjobid}&user_domain_id=${esodata.domaindata.value.header_selected}&campaign_id=${campaign}&search_engine_id=${SearchEngine}&country_id=${Country}&state_id=${value.value}&filter_type=city`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });

      if (citydatavalue?.data) {
        if (citydatavalue?.data?.cities) {
          var Sections = [];
          citydatavalue.data.cities.forEach((element) => {
            Sections.push({ label: element.search_engine_locale__city__city_name, value: element.search_engine_locale__city__id });
          });
          SetCityOptions(Sections);
          SetdCity(Sections[0])
        }
      }
    }
  };


  const rows = cardData ?? [];
  const apihandleClose = () => {
    setapiOpen(false);
  };

  const finalreportNow = async () => {
    setLoading(true);
    SetErrorMsg("");
    setColumns([]);


    var StateId = '';
    var CityId = '';



    if (State.value) {
      StateId = State.value

    }
    if (City.value) {
      CityId = City.value
    }




    if (selectjobid !== "" || campaign !== "" || SearchEngine !== "" || Country !== "" || StateId !== "" || CityId !== "" || System !== '' || Device !== '') {


      const datavalue = await axios
        .get(
          `${process.env.REACT_APP_API_URL}keywords/v2/competitor_ranking_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectjobid}&campaign_id=${campaign}&search_engine_id=${SearchEngine}&country_id=${Country}&state_id=${StateId}&city_id=${CityId}&system=${System}&devices=${Device}`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          }
        )
        .catch((error) => {
          if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
          }
          else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
            navigate('/errorpages')
          }
        });

      const dataval = datavalue?.data?.result;
      if (datavalue?.data?.competitors && datavalue?.data?.competitors.length > 0) {
        var Sections = [];
        datavalue?.data?.competitors.forEach((element) => {
          Sections.push({ label: element.name, value: element.id });
        });
      }
      setCompetitors(Sections);
      const header_data = datavalue?.data?.headers;
      setReportdata(datavalue?.data?.headers)
      setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"));
      if (columns) {
        var colum = []
        if (header_data) {

          header_data.forEach(element => {
            colum.push({
              field: element,
              headerName: element,
              minWidth: 200,
              flex: 1,
              disableClickEventBubbling: true,
              headerAlign: "center",
              align: "center",
            })

          });

          var cpy_array = [


            {
              field: "keyword",
              headerName: "Keywords",
              description: 'The list of keywords is provided in campaign settings.',
              minWidth: 170,
              flex: 1,
              disableClickEventBubbling: true,
              headerAlign: "center",
              align: "center",
              sortable: true,
            },
            {
              field: "intent",
              headerName: "Intent",
              description: "A keyword's total search volume in search results.",
              minWidth: 200,
              flex: 1,
              disableClickEventBubbling: true,
              headerAlign: "center",
              align: "center",
              sortable: true,
              valueGetter: (params) => params.row.intent ?? "-"
            },

            {
              field: "searchvolume",
              headerName: "SV",
              description: "A keyword's total search volume in search results.",
              minWidth: 100,
              flex: 1,
              disableClickEventBubbling: true,
              headerAlign: "center",
              align: "center",
              sortable: true,
              valueGetter: (params) => params.row.searchvolume ?? null,
            },
            {
              field: "difficulty",
              headerName: "Difficulty",
              description: "The value-based display of keyword difficulty for the respective keyword",
              minWidth: 200,
              flex: 1,
              headerAlign: "center",
              align: "center",
              sortable: true,
              valueGetter: (params) => params.row.difficulty ?? null,
            },
            {
              field: "sv_trend_chart_data",
              headerName: "Monthly Searches",
              description: "The last 12 months' search volume is shown visually as a simple small bar graph for the keyword. ",
              minWidth: 200,
              flex: 1,
              headerAlign: "center",
              align: "center",
              sortable: false,
              renderCell: (cardData) => {
                var sr = cardData.row.sv_trend_chart_data;
                if (sr != null && Array.isArray(sr) && sr.length > 0) {

                  var monthval = sr.map((item) => {
                    const monthName = new Date(item.year, item.month - 1).toLocaleString("en-US", { month: "long" });
                    return `${monthName} ${item.year}`;
                  });
                  var chartdataval = sr.map((fruit) => fruit.search_volume);

                  return (
                    <ChartContainer
                      width={200}
                      height={150}
                      series={[{ data: chartdataval, label: "Search Volume", type: "bar" }]}
                      xAxis={[{ scaleType: "band", data: monthval }]}
                    >
                      <BarPlot />
                      <ChartsTooltip />
                    </ChartContainer>
                  );
                }
                else {
                  return "N/A";
                }
              },
            },
            {
              field: "search_engine",
              headerName: "Search Engine",
              description: 'List of search engines configured in the campaign settings.',
              minWidth: 250,
              flex: 1,
              headerAlign: "center",
              align: "center",
              renderCell: (cardData) => {


                if (cardData.row.search_engine === 'Bing') {

                  return (

                    <div className="search_engine_row">
                      <img src={BingPng} />{cardData.row.search_engine}

                    </div>

                  )

                }
                else if (cardData.row.search_engine === 'Google') {

                  return (

                    <div className="search_engine_row">
                      <img src={GooglePng} />{cardData.row.search_engine}
                    </div>

                  )

                }
                else {

                  return (


                    cardData.row.search_engine


                  )

                }

              }
            },
            {
              field: "country",
              headerName: "Location",
              description: 'The list of locations is configured in the campaign settings.',
              minWidth: 150,
              flex: 1,
              headerAlign: "center",
              align: "center",
              renderCell: (cardData) => {

                return (

                  <>
                    <>
                      <div> {cardData.row.country} {cardData.row.state ? `,` : ""}<br />
                        {cardData.row.state}{cardData.row.city ? `,` : ""}<br />
                        {cardData.row.city ? `${cardData.row.city}` : ""}</div>
                    </>
                  </>

                )

              }
            },
          ];
          var c = cpy_array.concat(colum);

          setColumns(c)
          if (dataval && dataval.length > 0) {
            const newData = dataval.map((obj, index) => {
              return { ...obj, sid: index + 1 };
            });


            setCardData(newData);
            SetAutoheightval(false)
          }

        }
        else {
          setCardData("");
          SetAutoheightval(true)
        }
        if (datavalue?.data) {
          setSummaryData({
            "kpis": datavalue?.data?.kpis || {},
            "visibility_share": {
              labels: datavalue?.data?.charts.visibility_share?.labels || [],
              top_3: datavalue?.data?.charts.visibility_share?.top_3 || [],
              top_10: datavalue?.data?.charts.visibility_share?.top_10 || [],
            },
          })
        }
      }
    }
    else {
      setLoading(false);
      return SetErrorMsg("Please Select the any one of the value !");

    }
    setIsOpen(false);
    setprevdselectjobid(dselectjobid);
    setLoading(false);
  }

  const reportNow = async () => {
    setLoading(true);
    var errs = 1;
    let errors = {};
    if (selectval.length === 0 || selectsecondval.length === 0) {
      errors.dateerror = "Please Select Job id.";
      errs = 2;
    } else {
      errors.dateerror = "";
      errs = 1;

    }
    if (errs === 2) {
      setLoading(false);
      return setValidation(errors);
    }
    setValidation(errors);
    callUserdataApi(selectval[0].id, selectsecondval[0].id)
    closeModal();
    setLoading(false);
  };
  function openModal() {
    setIsOpen(true);
    setfaqData(2)
    setToggle(false)
  }
  function closeModal() {
    setIsOpen(false);
    setdselectjobid(prevdselectjobid);
  }
  function dataChange(e) {
    let dataval_id = e[0].id
    let fun_name = 1
    calljobiddata(dataval_id, fun_name)
  }
  function datavalChange(e) {
    let dataval_id = e[0].id;
    let fun_name = 2
    calljobiddata(dataval_id, fun_name)
  }
  const calljobiddata = async (dataval_id = "", fun_name = "") => {
    setLoading(true);
    setTableLoading(true);

    const datedatavalue = await axios
      .get(
        `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?job_type=site_audit&user_domain_id=${dataval_id}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      )
      .catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
    setLoading(false)
    setTableLoading(false);

    if (fun_name == 1)
      setReportdata(datedatavalue.data.jobs)
    else if (fun_name == 2)
      setReporttwodata(datedatavalue.data.jobs)
  }

  const LoadAddFormFilterOptions = async (jobid = "") => {
    setjobidData([]);
    SetSectionOptions([]);
    SetCountryoptions([]);
    SetEngineoptions([]);
    Setcampaignoption([])
    try {
      const campaigndatavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/ranking_filter/?job_id=${selectjobid}&user_domain_id=${esodata.domaindata.value.header_selected}&search_engine_id=${SearchEngine}&country_id=${Country}&state_id=${State}&city_id=${City}&filter_type=campaign`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (campaigndatavalue?.data?.campaigns) {
        if (campaigndatavalue.data.campaigns) {
          var campaignSections = [];
          campaigndatavalue.data.campaigns.forEach((element) => {
            campaignSections.push({ label: element.category__name, value: element.category__id });
          });
          Setcampaignoption(campaignSections);
          Setdcampaignoption(campaignSections[0])
        }
      }
    } catch (err) { }
    try {
      const jobdatavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?user_domain_id=${esodata.domaindata.value.header_selected}&job_type=rankings_summary`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (jobdatavalue?.data?.jobs) {
        if (jobdatavalue.data.jobs) {
          // var jobSections = [];
          // jobdatavalue.data.jobs.forEach((element) => {
          //   jobSections.push({ label: datezonechange(element.completed_at), value: element.id });
          // });
          const uniqueByCompletedAt = removeDuplicateDate(jobdatavalue?.data?.jobs);
          if (uniqueByCompletedAt.length > 0)
            setdselectjobid(uniqueByCompletedAt[0]);
          setprevdselectjobid(uniqueByCompletedAt[0]);
          setjobidData(uniqueByCompletedAt);
        }
      }
    } catch (err) { }
    try {
      const enginedatavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/ranking_filter/?job_id=${jobid}&user_domain_id=${esodata.domaindata.value.header_selected}&campaign_id=${campaign}&country_id=${Country}&state_id=${State}&city_id=${City}&filter_type=search_engine`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (enginedatavalue?.data?.search_engines) {
        if (enginedatavalue?.data?.search_engines) {
          var Sections = [];
          enginedatavalue.data.search_engines.forEach((element) => {
            Sections.push({ label: element.search_engine_locale__search_engine__name, value: element.search_engine_locale__search_engine__id });
          });
          SetEngineoptions(Sections);
          SetdSearchEngine(Sections[0])
        }
      }
    } catch (err) { }
    try {
      const countrydatavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/ranking_filter/?job_id=${jobid}&user_domain_id=${esodata.domaindata.value.header_selected}&campaign_id=${campaign}&search_engine_id=${SearchEngine}&state_id=${State}&city_id=${City}&filter_type=country`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });

      if (countrydatavalue?.data?.countries) {
        if (countrydatavalue?.data?.countries) {
          var Sections = [];
          countrydatavalue.data.countries.forEach((element) => {
            Sections.push({ label: element.search_engine_locale__country__name, value: element.search_engine_locale__country__id });
          });
          SetCountryoptions(Sections);
          SetdCountryHandle(Sections[0])
          SetdStateHandle(Sections[0])
          SetdCity(Sections[0])
        }
      }
    } catch (err) { }



  };
  function elementval(element) {
    const dataval = element.split()
    return 150;
  }
  const callUserdataApi = async (jobid = "", secondjobid = "") => {
    setLoading(true);
    setTableLoading(true);

    try {

      const datavalue = await axios
        .get(
          `${process.env.REACT_APP_API_URL}keywords/v2/competitor_ranking_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          }
        )
        .catch((error) => {
          if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
          }
          else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
            navigate('/errorpages')
          }
        });


      const dataval = datavalue?.data?.result;
      if (datavalue?.data?.competitors && datavalue?.data?.competitors.length > 0) {
        var Sections = [];
        datavalue?.data?.competitors.forEach((element) => {
          Sections.push({ label: element.name, value: element.id });
        });
      }
      setCompetitors(Sections);
      const header_data = datavalue?.data?.headers;
      setReportdata(datavalue?.data?.headers)
      if (datavalue?.data?.job_date)
        setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"))
      else
        setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY"))

      if (columns) {
        const colum = [];

        if (Array.isArray(header_data) && header_data.length > 0) {
          header_data.forEach(element => {
            colum.push({
              field: element,
              headerName: element,
              width: 200,
              disableClickEventBubbling: true,
              headerAlign: "center",
              align: "center"
            });
          });
        }

        const cpy_array = [

          {
            field: "keyword",
            headerName: "Keywords",
            description: 'The list of keywords is provided in campaign settings.',
            minWidth: 170,
            flex: 1,
            disableClickEventBubbling: true,
            headerAlign: "center",
            align: "center",
            sortable: true,
          },
          {
            field: "intent",
            headerName: "Intent",
            description: "A keyword's total search volume in search results.",
            minWidth: 200,
            flex: 1,
            disableClickEventBubbling: true,
            headerAlign: "center",
            align: "center",
            sortable: true,
            valueGetter: (params) => params.row.intent ?? "-"
          },
          {
            field: "searchvolume",
            headerName: "SV",
            description: "A keyword's total search volume in search results.",
            minWidth: 100,
            flex: 1,
            disableClickEventBubbling: true,
            headerAlign: "center",
            align: "center",
            sortable: true,
            // valueGetter: (params) => params.row.SV ?? null,
          },
          {
            field: "difficulty",
            headerName: "Difficulty",
            description: "The value-based display of keyword difficulty for the respective keyword",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: true,
            valueGetter: (params) => params.row.difficulty ?? null,
          },
          {
            field: "Monthly Searches",
            headerName: "Monthly Searches",
            description: "The last 12 months' search volume is shown visually as a simple small bar graph for the keyword. ",
            minWidth: 200,
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
            renderCell: (cardData) => {
              const sr = cardData.row.sv_trend_chart_data;
              if (Array.isArray(sr) && sr.length > 0) {
                const monthval = sr.map((item) => {
                  const monthName = new Date(item.year, item.month - 1).toLocaleString("en-US", { month: "long" });
                  return `${monthName} ${item.year}`;
                });
                const chartdataval = sr.map((fruit) => fruit.search_volume);

                return (
                  <ChartContainer
                    width={200}
                    height={150}
                    series={[{ data: chartdataval, label: "Search Volume", type: "bar" }]}
                    xAxis={[{ scaleType: "band", data: monthval }]}
                  >
                    <BarPlot />
                    <ChartsTooltip />
                  </ChartContainer>
                );
              } else {
                return "N/A";
              }
            },
          },
          {
            field: "search_engine",
            headerName: "Search Engine",
            description: "List of search engines configured in the campaign settings.",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (cardData) => {
              const engine = cardData.row.search_engine;
              if (engine === 'Bing') {
                return (
                  <div className="search_engine_row">
                    <img src={BingPng} alt="Bing" />{engine}
                  </div>
                );
              } else if (engine === 'Google') {
                return (
                  <div className="search_engine_row">
                    <img src={GooglePng} alt="Google" />{engine}
                  </div>
                );
              } else {
                return engine;
              }
            },
          },
          {
            field: "country",
            headerName: "Location",
            description: "The list of locations is configured in the campaign settings.",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (cardData) => (
              <>
                {cardData.row.country}
                {cardData.row.state ? `, ${cardData.row.state}` : ""}
                {cardData.row.city ? `, ${cardData.row.city}` : ""}
              </>
            ),
          },
        ];

        const finalColumns = cpy_array.concat(colum);
        setColumns(finalColumns);

        if (dataval && dataval.length > 0) {
          SetAutoheightval(false);
          const newData = dataval.map((obj, index) => ({ ...obj, sid: index + 1 }));
          setCardData(newData);
        } else {
          setCardData("");
          SetAutoheightval(true);
        }

        if (datavalue?.data) {
          setSummaryData({
            "kpis": datavalue?.data?.kpis || {},
            "visibility_share": {
              labels: datavalue?.data?.charts.visibility_share?.labels || [],
              top_3: datavalue?.data?.charts.visibility_share?.top_3 || [],
              top_10: datavalue?.data?.charts.visibility_share?.top_10 || [],
            },
          })
        }
      }


    } catch (err) {
      console.log(err)
    }

    setLoading(false);
    setTableLoading(false);
  };
  var startColor = "#6495ed";
  var endColor = "#dc143c";
  const interpolate = interpolateRgb(startColor, endColor);
  const fillColor = "rgb(255,174,31)";
  const textfillColor = "rgb(255,255,255)";
  const gradientStops = [
    {
      key: "0%",
      stopColor: color(fillColor).darker(0.5).toString(),
      stopOpacity: 1,
      offset: "0%",
    },
    {
      key: "50%",
      stopColor: fillColor,
      stopOpacity: 0.75,
      offset: "50%",
    },
    {
      key: "100%",
      stopColor: color(fillColor).brighter(0.5).toString(),
      stopOpacity: 0.5,
      offset: "100%",
    },
  ];

  const onSelectCompetitor = (selectedList) => {
    if (selectedList.length > 6) {
      setSelectCompError('Six competitor only allowed');
    } else {
      setCompetitorsValue(selectedList);
      setSelectCompError(null);
    }
  }

  const pdfdown = async () => {

    setLoading(true);
    setIsDownloading(true);

    var selectedComp = [];
    if (competitorsValue && competitorsValue.length > 6) {
      setSelectCompError('Please select maximum 6 competitor');
    } else if (!competitorsValue || competitorsValue.length < 1) {
      setSelectCompError('Please select minimum 1 competitor');
    } else if (competitorsValue) {
      setSelectCompError(null);
      selectedComp = competitorsValue.map(comp => comp.value).join(',');


      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}keywords/v2/competitor_ranking_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectjobid}&campaign_id=${campaign}&search_engine_id=${SearchEngine}&country_id=${Country}&state_id=${State}&city_id=${City}&system=${System}&devices=${Device}&formats=pdf&timezone=${timezoneval()}&competitor_ids=${selectedComp}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/pdf',
            Authorization: `${ApiToken}`,
          },
        });
        if (response.ok) {
          const blob = await response.blob();

          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          var filedata = await Commonfun("Competitorlist", "pdf", ApiToken, esodata.domaindata.value.header_selected);
          link.download = filedata;
          link.click();


          window.URL.revokeObjectURL(link.href);
        } else {
          if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
            response.json().then(data => {
              setapiOpen(true);
              setapierrorMsg(data?.error)
            })
          }
          else if (response?.code == "ERR_NETWORK") {
            navigate('/errorpages')
          }
        }
      } catch (error) {
        toast.error("No Data", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

        console.error('Error during PDF download:', error);
      }
    }
    setLoading(false);
    setIsDownloading(false);

  }
  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}keywords/v2/competitor_ranking_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectjobid}&campaign_id=${campaign}&search_engine_id=${SearchEngine}&country_id=${Country}&state_id=${State}&city_id=${City}&system=${System}&devices=${Device}&formats=csv&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("Competitorlist", "csv", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);
  }

  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };

  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=9`

    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (doaminsectiondatavalue?.data) {

        SetInitialDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }

  const regionalsetting = () => {
    navigate('/competitor-settings');
  }

  const GetCompetitors = async () => {

    try {
      const dataValues = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_competitor_domains/?user_domain_id=${esodata.domaindata.value.header_selected}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });

      if (dataValues?.data?.table?.competitors && dataValues?.data?.table?.competitors.length > 0) {
        console.log(dataValues);
        var Sections = [];
        dataValues?.data?.table?.competitors.forEach((element) => {
          Sections.push({ label: element.competitor_name, value: element.id });
        });
      }
      setCompetitors(Sections);

    } catch (err) {
      console.log('err in getcompetiors: ' + err);
    }
  }


  const freeAudit = async () => {
    const check = await Utils("competitor_ranking", ApiToken);
    setfreesiteaudit(check);
    if (check.status) {
      callUserdataApi();
      LoadAddFormFilterOptions();
      // GetCompetitors();
    }
  }


  useEffect(() => {
    freeAudit();
    faqdatafun()
  }, [])

  function handleReset() {
    Setdcampaignoption("");
    setdselectjobid("");
    SetdSearchEngine("");
    SetdCountryHandle("");
    SetdStateHandle("");
    SetdCity("");
    setselectjobid("");
  }

  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    setCompetitorModel(true);
  };
  const handleModelPopUp = () => {
    openModal();
  }

  const urls = Array.isArray(summaryData?.visibility_share)
    ? summaryData.top_5_worst_urls
    : [];

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false }
    },
    colors: ["#0e3198", "#099136", "#fc9d28"],
    plotOptions: {
      bar: {
        horizontal: true, // better for long URLs
        barHeight: "60%"
      }
    },
    xaxis: {
      categories: summaryData?.visibility_share?.labels,
      labels: {
        show: false   // 👈 hides numbers/text on x-axis
      },
      axisBorder: {
        show: false   // optional: remove axis line
      },
      axisTicks: {
        show: false   // optional: remove ticks
      }
    },
    yaxis: {
      labels: {
        maxWidth: 150
      }
    },
    grid: {
      padding: {
        left: 20,
        right: 20
      }
    },
    tooltip: {
      x: {
        formatter: (val, opts) => summaryData?.visibility_share?.labels[opts.dataPointIndex]
      },
      y: {
        formatter: (val) => val
      }
    }
  };

  const chartSeries = [
    {
      name: "Top 3",
      data: summaryData?.visibility_share?.top_3 || []
    },
    {
      name: "Top 10",
      data: summaryData?.visibility_share?.top_10 || []
    }
  ];


  return (
    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Competitor Ranking</title>
      </Helmet>
      {
        loading === true ? <Loader /> : null
      }

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  Competitor Ranking
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Keywords' },
                      { title: 'Competitor Ranking', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
              <div className="time_zone">
                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                <span className="timezone-val">{timezoneval()}</span>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="drop_down_button">
                <button class="btn_dashboard" onClick={regionalsetting} disabled={!freesiteaudit.status} >Competitor Settings</button>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Grid container spacing={2} style={{ marginBottom: '20px' }}>

          <Grid item xs={12} md={6}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '400px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Average Rank Comparison</Typography>
              <Chart
                type="bar"
                height={350}
                series={[{
                  name: "Count",
                  data: (Object.keys(summaryData.kpis) || []).map(i => summaryData.kpis[i].avg_rank || 0)
                }]}
                options={{
                  chart: { toolbar: { show: false } },
                  plotOptions: {
                    bar: {
                      horizontal: false,
                      columnWidth: '45%',
                      borderRadius: 4,
                      distributed: true, // 👈 IMPORTANT
                      dataLabels: { position: 'top' }
                    }
                  },
                  colors: ["#3f51b5", "#d97757", "#00C9A7", "#FF4D4F", '#ae36ee', '#c9d429'], // 👈 each bar gets color
                  dataLabels: {
                    enabled: true,
                    offsetY: -20,
                    style: { fontSize: '12px' }
                  },
                  xaxis: {
                    categories: (Object.keys(summaryData.kpis) || []).map(i => i.length > 10 ? i.slice(0, 6) + '...' : i),
                    position: 'bottom',
                    labels: {
                      offsetX: 50,
                      style: { fontSize: '11px' }
                    }
                  },
                  yaxis: {
                    title: { text: 'Count' },
                    labels: { formatter: (val) => Math.floor(val) }
                  },
                  noData: { text: "No Metric Data Available" }
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '400px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Visibility Share Comparison</Typography>
              <Chart
                options={chartOptions}
                series={chartSeries}
                type="bar"
                height={350}
              />
            </Box>
          </Grid>

        </Grid>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                {freesiteaudit.status ?
                  <DatagridComp className="datagrid_custom_scroll"
                    columns={columns}
                    rows={rows}
                    autoheightval={autoheightval}
                    datagridval={2}
                    columnFreezeWidth={[0, 170]}
                    tableLoading={tableLoading}
                    DownloadShowPDF={1}
                    DownloadShowCSV={2}
                    customFilter={true}
                    DownloadShowFile={true}
                    handleModelPopUp={handleModelPopUp}
                    handleDownlodingCSV={handleDownlodingCSV}
                    handleDownlodingPDF={handleDownlodingPDF}
                  /> : <Freeaudit planStatus={freesiteaudit} />
                }
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <div className="cnt_audit_outer_wrap">
        {toggle && <Keywordbar close={() => setToggle(false)} setToggle={setToggle} initialDateval={initialDateval} />}
      </div>

      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2026 |
                  <a href="https://www.egrovesys.com/" target="blank">
                    <span className="footer-brand">Elite site Optimizer</span>
                  </a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p>{/* Add content if needed */}</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
      <Dialog
        open={modalIsOpen}
        onClose={closeModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter"
      >
        <DialogTitle className="keyword-dialog-header">{"Filter By"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description1" className="width-auto" style={{ width: "500px" }}>
            <div className="error_plagarism_report">{ErrorMsg}</div>
            <div className="dialog-input-form">
              <div className="row form-black" style={{ gap: "10px" }}>
                <div className="dialog-input-form-width">
                  <label className="form-label">Campaign</label>
                  <Select
                    value={dcampaignoption}
                    options={campaignoption}
                    placeholder="Select..."
                    onChange={(e) => {
                      Setcampaign(e.value);
                      Setdcampaignoption(e)
                    }}
                    styles={customDropdownStyles()}
                    // menuPortalTarget={document.body}
                    className="keyword-select-container"
                  />
                </div>
                <div className="dialog-input-form-width">
                  <label className="form-label">Completed Date</label>
                  <Select
                    value={dselectjobid}
                    options={jobidData}
                    placeholder="Select..."
                    onChange={(e) => {
                      setselectjobid(e.value);
                      setdselectjobid(e)
                    }}
                    styles={customDropdownStyles()}
                    menuPortalTarget={document.body}
                    className="keyword-select-container"
                  />
                </div>
              </div>
              <div className="row form-black" style={{ gap: "10px" }}>
                <div className="dialog-input-form-width">
                  <label className="form-label">Search Engine</label>
                  <Select
                    value={dSearchEngine}
                    options={Engineoptions}
                    placeholder="Select..."
                    onChange={(e) => {
                      SetSearchEngine(e.value);
                      SetdSearchEngine(e)
                    }}
                    styles={customDropdownStyles()}
                    menuPortalTarget={document.body}
                    className="keyword-select-container"
                  />
                </div>
                <div className="dialog-input-form-width">
                  <label className="form-label">Country</label>
                  <Select
                    value={dCountryHandle}
                    options={Countryoptions}
                    placeholder="Select..."
                    onChange={(e) => {
                      SetCountryHandle(e);
                      SetdCountryHandle(e)
                    }}
                    styles={customDropdownStyles()}
                    menuPortalTarget={document.body}
                    className="keyword-select-container"
                  />
                </div>
              </div>
              <div className="row form-black" style={{ gap: "10px" }}>
                <div className="dialog-input-form-width">
                  <label className="form-label">State</label>
                  <Select
                    value={dStateHandle}
                    options={Stateoptions}
                    placeholder="Select..."
                    onChange={(e) => {
                      SetStateHandle(e);
                      SetdStateHandle(e)
                    }}
                    styles={customDropdownStyles()}
                    menuPortalTarget={document.body}
                    className="keyword-select-container"
                  />
                </div>
                <div className="dialog-input-form-width">
                  <label className="form-label">City</label>
                  <Select
                    value={dCity}
                    options={CityOptions}
                    placeholder="Select..."
                    onChange={(e) => {
                      SetCity(e);
                      SetdCity(e)
                    }}
                    styles={customDropdownStyles()}
                    menuPortalTarget={document.body}
                    className="keyword-select-container"
                  />
                </div>
              </div>
              <div className="col">
                <label className="form-label">System</label>
                <div className="radio-group">
                  <label>
                    <input
                      type="radio"
                      name="system"
                      value="mobile"
                      onChange={(e) => SetSystem(e.target.value)}
                      checked={System === 'mobile'}
                    />
                    Mobile
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="system"
                      value="desktop"
                      onChange={(e) => SetSystem(e.target.value)}
                      checked={System === 'desktop'}
                    />
                    Desktop
                  </label>
                </div>
              </div>
              {System === 'mobile' && (
                <div className="col">
                  <label className="form-label">Devices</label>
                  <div className="radio-group">
                    <label>
                      <input
                        type="radio"
                        name="devices"
                        value="android"
                        checked={Device === 'android'}
                        onChange={(e) => SetDevice(e.target.value)}
                      />
                      Android
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="devices"
                        value="ios"
                        checked={Device === 'ios'}
                        onChange={(e) => SetDevice(e.target.value)}
                      />
                      iOS
                    </label>
                  </div>
                </div>
              )}

            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button className="form_submit_btn" onClick={finalreportNow} style={{ cursor: 'pointer' }} >
            Submit
          </button>
          <button className="form_submit_btn" style={{ cursor: 'pointer' }} onClick={closeModal}>close</button>
          <button
            className="form_submit_btn"
            style={{ cursor: "pointer" }}
            onClick={handleReset}>
            Reset
          </button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={competitorModel}
        onClose={() => setCompetitorModel(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter"
      >
        <DialogTitle className="keyword-dialog-header">{"Filter By"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="col">
              <label className="form-label">Competitor</label>
              <Select
                value={competitorsValue}
                options={competitors}
                isMulti
                menuPlacement="auto"
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                menuShouldScrollIntoView={false}
                components={{ CheckboxMultiSelectOption, ValueContainer: MultiValueCount, MultiValue }}
                onChange={onSelectCompetitor}
                getOptionLabel={option => option.label}
                getOptionValue={option => option.value}
                placeholder="Select Competitors..."
                styles={customCheckboxMultiSelect}
                menuPortalTarget={document.body}
              />
              <span className="error-value">{selectCompError}</span>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button className="form_submit_btn" onClick={pdfdown} style={{ cursor: 'pointer' }} >
            Submit
          </button>
          <button className="form_submit_btn" style={{ cursor: 'pointer' }} onClick={() => setCompetitorModel(false)}>close</button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="keyword-dialog-header">{"Error Message "}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            No Data Found
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>

      {!openCommonAlerts &&
        <>
          <CommonErrorAlert
            data={{
              apiopen: open,
              apiErrorMsg: 'No Data Found',
              isIconStyled: false
            }}
            closeAlert={handleClose} />
          <CommonErrorAlert
            data={{
              apiopen: apiopen,
              apiErrorMsg: apierrorMsg,
              isIconStyled: true
            }}
            closeAlert={apihandleClose} />
          <UserActivityTracker pagename="Keywords - Competitor Ranking" />
        </>
      }



    </div>
  );
}
